import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "Why are IC engines still widely used?",
    category: "Technology",
    description:
      "IC engines remain popular due to reliability, high energy density fuels, established infrastructure, affordable maintenance, and suitability for long-distance travel. Despite electric alternatives, IC engines dominate transportation and industrial sectors worldwide.",
  },
  {
    title: "What are the main types of IC engines?",
    category: "Trending",
    description:
      "The primary types are spark-ignition (petrol) engines and compression-ignition (diesel) engines. They differ in fuel type, ignition method, efficiency, and applications across automobiles, machinery, and industrial equipment.",
  },
  {
    title: "What skills are required to work with IC engines?",
    category: "Design",
    description:
      "You need knowledge of thermodynamics, combustion, fuel systems, lubrication, engine diagnostics, mechanical components, emission systems, and troubleshooting techniques to effectively maintain, repair, or design IC engines.",
  },
  {
    title: "What job roles are available in the IC engine field?",
    category: "Design",
    description:
      "Career roles include Engine Design Engineer, Test Engineer, Maintenance Engineer, Automotive Technician, Calibration Engineer, Emission Analyst, and Powertrain Engineer across automotive, aviation, and manufacturing sectors.",
  },
  {
    title: "What will I learn in the IC engine domain?",
    category: "Design",
    description:
      "You will learn engine fundamentals, combustion processes, fuel systems, performance analysis, emission control, diagnostics, maintenance, and real-world testing to understand how modern petrol and diesel engines operate and perform.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                {/* <div className="category">{item.category}</div> */}

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
